import React from 'react'

export function renderVisitors(ctx) {
  const {
    activeTab,
    lang,
    visitorLogs,
  } = ctx
  return (
    <>
          {activeTab === 'visitors' && (
            <div className="dash-section">
              <div className="dash-section-header">
                <h2>🌐 {lang === 'fr' ? 'Visiteurs du site' : 'Website Visitors'}</h2>
                <p>{lang === 'fr' ? 'Journal des accès au site public — IP, page visitée, appareil.' : 'Public website access log — IP, page visited, device.'}</p>
              </div>
              <div style={{ marginBottom: 16 }}>
                <span style={{ fontSize: '0.85rem', color: '#6b7280' }}>{visitorLogs.length} {lang === 'fr' ? 'entrées' : 'entries'}</span>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table className="dash-table">
                  <thead>
                    <tr>
                      <th>IP</th>
                      <th>{lang === 'fr' ? 'Page' : 'Page'}</th>
                      <th>{lang === 'fr' ? 'Référent' : 'Referrer'}</th>
                      <th>{lang === 'fr' ? 'Appareil' : 'Device'}</th>
                      <th>{lang === 'fr' ? 'Date/Heure' : 'Time'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visitorLogs.map(log => (
                      <tr key={log.id}>
                        <td style={{ fontFamily: 'monospace', fontSize: '0.82rem' }}>{log.ip || '—'}</td>
                        <td>{log.page || '/'}</td>
                        <td style={{ color: '#6b7280', fontSize: '0.82rem', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{log.referrer || '—'}</td>
                        <td style={{ fontSize: '0.75rem', color: '#6b7280', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {log.device ? log.device.slice(0, 60) + (log.device.length > 60 ? '…' : '') : '—'}
                        </td>
                        <td style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{new Date(log.visited_at).toLocaleString()}</td>
                      </tr>
                    ))}
                    {visitorLogs.length === 0 && (
                      <tr><td colSpan={5} style={{ textAlign: 'center', color: '#9ca3af', padding: '32px' }}>
                        {lang === 'fr' ? 'Aucun visiteur enregistré.' : 'No visitors logged yet.'}
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
    </>
  )
}
